import React, { useState } from 'react'
import { ActionsPanel } from './components/ActionsPanel'
import { useAppSelector } from '../../../core/hooks'
import { useFilterPatientsByDataOwnerQuery, useFilterPatientsByFuzzyNameForDataOwnerQuery, useGetPatientsByIdsQuery } from '../../../core/api/patientApi'
import { createSelector } from '@reduxjs/toolkit'
import { skipToken } from '@reduxjs/toolkit/query/react'
import { CardinalApiState } from '../../../core/services/auth.api'
import { PatientsTable } from './components/PatientsTable'
import './index.less'

const reduxSelector = createSelector(
  (state: { cardinalApi: CardinalApiState }) => state.cardinalApi,
  (cardinalApi: CardinalApiState) => ({
    dataOwnerId: cardinalApi.dataOwnerId,
  }),
)

export const PatientsDirectory = () => {
  const { dataOwnerId } = useAppSelector(reduxSelector)
  const [searchString, setSearchString] = useState<string | undefined>(undefined)

  const { data: patientsByDataOwnerIds, isLoading: patientsByDataOwnerIdsAreLoading } = useFilterPatientsByDataOwnerQuery(
    dataOwnerId && !searchString?.length ? dataOwnerId : skipToken,
  )
  const {
    data: patientsByFuzzyNameForDataOwnerIds,
    isLoading: patientsByFuzzyNameForDataOwnerIdsAreLoading,
    originalArgs: searchArgs,
  } = useFilterPatientsByFuzzyNameForDataOwnerQuery(dataOwnerId && searchString?.length ? { practitionerId: dataOwnerId, searchString: searchString.trim() } : skipToken)

  const patientsIdsList = searchString?.length ? patientsByFuzzyNameForDataOwnerIds : patientsByDataOwnerIds

  const { data: patientsListToRender, isLoading: patientListIsLoading } = useGetPatientsByIdsQuery(patientsIdsList ?? [], {
    skip: !!searchString?.length && searchArgs?.searchString !== searchString,
  })

  const noMatchingSearchPatients = !!searchString?.length && patientsIdsList?.length === 0

  return (
    <div className="patientsDirectory">
      <ActionsPanel onSearch={setSearchString} onClear={() => setSearchString(undefined)} />
      <PatientsTable
        patientList={patientsListToRender}
        showSpinner={patientsByDataOwnerIdsAreLoading || patientListIsLoading || patientsByFuzzyNameForDataOwnerIdsAreLoading}
        noMatchingSearchPatients={noMatchingSearchPatients}
      />
    </div>
  )
}
